import React from 'react';
import Navbar from '../components/navbar/navbar';
import Index from '../components/product';

const Product = () => {
    return (
        <div>
            <Navbar/>
            <Index/>
        </div>
    );
}

export default Product;
